import * as React from 'react';
import { forwardRef } from 'react';

export type DMButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const DMButton = forwardRef<HTMLButtonElement, DMButtonProps>(
  ({ className = '', type = 'button', children, ...props }, ref) => {
    return (
      <button ref={ref} type={type} className={className} {...props}>
        {children}
      </button>
    );
  }
);
DMButton.displayName = 'DMButton';
